import { InputHTMLAttributes } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";
import Select from "react-select";
import "./SelectField.css";

interface InputTextProps {
  label: string;
  name: string;
  defaultValue?: { value: string; label: string };
  control: Control<FieldValues>;
  required?: boolean;
  requiredMessage?: string;
  placeholder?: string;
  rules?: Object;
  inputProps?: InputHTMLAttributes<HTMLSelectElement>;
  options: { value: string; label: string }[] | string[];
  disabled?: boolean;
  isClearable?: boolean;
  isSearchable?: boolean;
  onChange?: (val: any) => void;
  labelClassName?: string;
  wrapperClassName?: string;
}

function SelectField({
  label,
  name,
  control,
  required,
  requiredMessage,
  rules = {},
  defaultValue,
  placeholder,
  disabled = false,
  onChange = () => {},
  options = [],
  labelClassName = "",
  wrapperClassName = "",
  isSearchable = false,
  isClearable = false,
}: InputTextProps) {
  return (
    <Controller
      name={name}
      rules={{
        required: requiredMessage || (required && "Please select an option"),
        ...rules,
      }}
      control={control}
      disabled={disabled}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <div className={`relative ${wrapperClassName}`}>
          <label
            className={`inline-block text-gray-500 pb-1 text-sm ${labelClassName}`}
          >
            {label}
            {required && <span className="text-red-500">*</span>}
          </label>
          <div className="relative flex-1">
            <Select
              id={field.name}
              {...field}
              onChange={(e) => {
                field.onChange(e);
                onChange(e);
              }}
              defaultValue={defaultValue}
              isClearable={isClearable}
              isSearchable={isSearchable}
              options={options}
              placeholder={placeholder || label}
              classNamePrefix="react-select"
              className="w-full text-sm bg-gray-50"
            />
          </div>
          <p className="text-red-600 font-normal text-sm m-0 p-0 ml-1  bottom-0 left-0 right-0">
            {error?.message}
          </p>
        </div>
      )}
    />
  );
}

export default SelectField;
